import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { debounceTime, filter } from "rxjs";
import { tap } from "rxjs/operators";

import { ToastService } from "@app/core/services/toast.service";
import { AuthPageActions } from "@app/features/auth/store/auth.actions";
import { isLoadingUserDetails } from "@app/features/auth/store/auth.selectors";
import { Store } from "@ngrx/store";

@Component({
  selector: "under-ui-root",
  templateUrl: "under-ui.component.html",
  styleUrl: "under-ui.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnderUiComponent implements OnInit {
  loaderUserDetails$ = this.store.select(isLoadingUserDetails);

  constructor(
    private readonly store: Store,
    private readonly swUpdate: SwUpdate,
    private readonly toastService: ToastService,
  ) {}

  ngOnInit(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.pipe(
        filter((event) => event.type === 'VERSION_READY'),
        tap(() => this.toastService.showInfo("New version available")),
        debounceTime(1000)
      ).subscribe(() => window.location.reload());
    }

    this.getUser();
  }

  getUser(): void {
    this.store.dispatch(AuthPageActions.getUser());
  }
}
